import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { TransactionsService } from '../../../core/functions/transactions.service';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'makaw-piechart',
  templateUrl: './piechart.component.html',
  styleUrls: ['./piechart.component.scss'],
})
export class PiechartComponent implements OnInit, OnDestroy {
  @Input() transaction$: Observable<any[]>;
  private destroyed$ = new Subject();
  public transactions;

  /* PieChart */
  public pieChartLabels = [
    'Health',
    'Home',
    'Basics',
    'Learning',
    'Party',
    'Car',
    'Market',
  ];
  public pieChartData: number[] = [1, 2, 3, 4, 5, 6, 7];
  public pieChartType = 'pie';
  public pieChartColors = [
    {
      backgroundColor: [
        'rgba(255,0,0,0.3)',
        'rgba(0,255,0,0.3)',
        'rgba(0,0,255,0.3)',
        'rgba(255,0,255,0.3)',
        'rgba(255,255,0,0.3)',
        'rgba(255,115,0,0.3)',
        'rgba(255,115,0,0.3)',
        'rgba(255,0,255,0.3)',
        'rgba(100,0,255,0.3)',
      ],
    },
  ];
  private currentMonthView = false;
  private incomeState = false;
  private expenseState = false;
  private bothState = true;

  constructor(private transactionService: TransactionsService) {}

  ngOnInit() {
    this.transaction$
      .pipe(takeUntil(this.destroyed$))
      .subscribe((transactions) => {
        this.transactions = transactions;
        this.paintBoth();
      });
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  paintIncomes() {
    this.updateStates('Incomes');
    let _arrayIncomes = this.transactionService.getIncomes(this.transactions);
    this.paintGraph(this.currentMonthView, _arrayIncomes);
  }

  paintExpenses() {
    this.updateStates('Expenses');
    let _arrayExpenses = this.transactionService.getExpenses(this.transactions);
    this.paintGraph(this.currentMonthView, _arrayExpenses);
  }

  paintBoth() {
    this.updateStates('Both');
    this.paintGraph(this.currentMonthView, this.transactions);
  }

  updateStates(state) {
    switch (state) {
      case 'Incomes':
        this.incomeState = true;
        this.expenseState = false;
        this.bothState = false;

        break;
      case 'Expenses':
        this.incomeState = false;
        this.expenseState = true;
        this.bothState = false;

        break;
      case 'Both':
        this.incomeState = false;
        this.expenseState = false;
        this.bothState = true;

        break;

      default:
        break;
    }
  }

  changeTypeBasedOnTheState() {
    if (this.incomeState) this.paintIncomes();
    if (this.expenseState) this.paintExpenses();
    if (this.bothState) this.paintBoth();
  }

  /* Dates */

  paintTotal() {
    this.currentMonthView = false;
    this.changeTypeBasedOnTheState();
  }

  paintByMonth() {
    this.currentMonthView = true;
    this.changeTypeBasedOnTheState();
  }

  paintGraph(currentMonthView, transactions) {
    this.pieChartLabels = this.transactionService.getAllCategories(
      transactions
    );
    if (currentMonthView) {
      this.pieChartLabels = this.transactionService.getCategoriesOfThisMonth(
        this.pieChartLabels,
        transactions
      );

      this.pieChartData = this.transactionService.calculateAcumulatedByCategoriesOfThisMonth(
        this.pieChartLabels,
        transactions
      );
    } else {
      this.pieChartData = this.transactionService.calculateAcumulatedByCategoires(
        this.pieChartLabels,
        this.transactions
      );
    }
  }
}
